// extracted by mini-css-extract-plugin
export var contacts = "contacts-module--contacts--Gb7e0";
export var contactsIcon = "contacts-module--contacts-icon--XF5w-";
export var contactsItem = "contacts-module--contacts-item--N-7Gn";
export var contactsTitle = "contacts-module--contacts-title--GVCZc";